import React from 'react'
// eslint-disable-next-line no-restricted-imports
import {clientI18n} from '../../../../../code/client/shared/scripts/ClientI18n'
import {TranslationKeys, TranslationObject, TranslationOptions} from '@colonist/i18n'

export const t = (id: TranslationObject | TranslationKeys, options?: TranslationOptions): string => {
    if(typeof id === 'string') {
        return clientI18n.t(id, options)
    } else {
        return clientI18n.t(id.key, id.options)
    }
}

export const T = (props: {
    id: TranslationObject | TranslationKeys
    options?: TranslationOptions
}) => <>
    {t(props.id, props.options)}
</>
